import { render, staticRenderFns } from "./order-item-form.vue?vue&type=template&id=773d951d"
import script from "./order-item-form.vue?vue&type=script&lang=js"
export * from "./order-item-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports